import { ElevatorEconomyLarge } from "@/domains/estate/components/elevator/components/economy/ElevatorEconomyLarge";
import { ElevatorEconomyMedium } from "@/domains/estate/components/elevator/components/economy/ElevatorEconomyMedium";
import { ElevatorEconomySmall } from "@/domains/estate/components/elevator/components/economy/ElevatorEconomySmall";

export type ElevatorEconomyProps = {
  currentFloor: number;
  targetFloor: number;
  floors: number[];
  onTargetFloorChange: (floor: number) => void;
  size: "sm" | "md" | "lg";
};

export function ElevatorEconomy({
  currentFloor,
  targetFloor,
  floors,
  onTargetFloorChange,
  size,
}: ElevatorEconomyProps) {
  if (size === "sm") {
    return (
      <ElevatorEconomySmall
        currentFloor={currentFloor}
        targetFloor={targetFloor}
        floors={floors}
        onTargetFloorChange={onTargetFloorChange}
      />
    );
  }

  if (size === "md") {
    return (
      <ElevatorEconomyMedium
        currentFloor={currentFloor}
        targetFloor={targetFloor}
        floors={floors}
        onTargetFloorChange={onTargetFloorChange}
      />
    );
  }

  if (size === "lg") {
    return (
      <ElevatorEconomyLarge
        currentFloor={currentFloor}
        targetFloor={targetFloor}
        floors={floors}
        onTargetFloorChange={onTargetFloorChange}
      />
    );
  }
}
